export default function initHeroVideo() {
  document.addEventListener('DOMContentLoaded', () => {
    const video = document.querySelector('.hero__video');
    const toggle = document.querySelector('.hero__video-toggle');

    if (!video || !toggle) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function syncToggle() {
      toggle.classList.toggle('is-paused', video.paused);
      toggle.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
    }

    video.addEventListener('play', syncToggle);
    video.addEventListener('pause', syncToggle);

    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    reducedMotion.addEventListener('change', (e) => {
      if (e.matches) video.pause();
    });

    if (!reducedMotion.matches) {
      video.play().catch(() => {});
    }

    syncToggle();
    toggle.hidden = false;
  });
}
